export type PostVehicleGroupApiResponse =
  | /** status 200 Standard response */ ({
      vehicleGroupId: string;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostVehicleGroupApiArg = {
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleModel_families?: (string | null)[];
    vehicleType?: string | null;
  } | null;
};
export type GetVehicleGroupApiResponse =
  | /** status 200 Standard response */ ({
      vehicleGroupId: string;
      name: string;
      vehicleMakes?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleModel_families?: (string | null)[];
      vehicleType?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetVehicleGroupApiArg = {
  vehicleGroupId: string;
};
export type DeleteVehicleGroupApiResponse = unknown;
export type DeleteVehicleGroupApiArg = {
  vehicleGroupId: string;
};
export type PatchVehicleGroupApiResponse =
  | /** status 200 Standard response */ ({
      vehicleGroupId: string;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchVehicleGroupApiArg = {
  vehicleGroupId: string;
  body: {
    name: string;
    vehicleMakes?: (string | null)[];
    vehicleModels?: (string | null)[];
    vehicleModel_families?: (string | null)[];
    vehicleType?: string | null;
  } | null;
};
export type GetVehicleGroupsApiResponse =
  /** status 200 Standard response */
  | ({
      vehicleGroupId: string;
      name: string;
      vehicleMakes?: (string | null)[];
      vehicleModels?: (string | null)[];
      vehicleModel_families?: (string | null)[];
      vehicleType?: string | null;
      isActive?: boolean | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetVehicleGroupsApiArg = unknown;
export type PostVehicleGroupSetAsActiveApiResponse = unknown;
export type PostVehicleGroupSetAsActiveApiArg = {
  vehicleGroupId: string;
};
export type PostVehicleGroupSetAsInactiveApiResponse = unknown;
export type PostVehicleGroupSetAsInactiveApiArg = {
  vehicleGroupId: string;
};
